<template>
    <div class="o-flex-cols__row--2col">
        <h2>{{ title }}</h2>
    </div>
</template>

<style lang="scss">

</style>

<script>
export default {
  name: 'TitlePage',
  props: {
    title: {
      type: String,
      default: 'Titulo de página',
    },
  },
}
</script>
